module.exports = __webpack_public_path__ + "static/media/81Vflp-UswL._AC_UX569_.fa3acd8c.jpg";